import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { MobileMode } from 'app/services/mobile-mode.service';

@Component({
  selector: 'app-mobile-mode-selector',
  templateUrl: './mobile-mode-selector.component.html',
  styleUrls: ['./mobile-mode-selector.component.scss'],
  imports: [TranslocoModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileModeSelectorComponent {
  readonly modeSelected = output<MobileMode>();

  protected selectMode(mode: MobileMode): void {
    this.modeSelected.emit(mode);
  }
}
